import {Component, Input, OnChanges, SimpleChanges, ViewChild,} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {MatSelectionList} from "@angular/material/list";
import {InputBaseComponent} from "../../base/input-base.component";

@Component({
  selector: "tva-list",
  templateUrl: "./tv-action-list.component.html",
  styleUrls: ["./tv-action-list.component.css"],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: TvActionListComponent,
    multi: true
  }]
})
export class TvActionListComponent
  extends InputBaseComponent implements OnChanges {
  @Input() items: any[];
  @Input() itemLabel = "label";
  @Input() itemValue: string;
  @Input() label: string;
  @Input() header: string;
  @Input() disabled: boolean;

  @ViewChild(MatSelectionList) selection: MatSelectionList;

  constructor() {
    super();
  }

  ngOnChanges(change: SimpleChanges) {
    if (change['formControl']) {
      change['formControl'].currentValue.valueChanges.subscribe((value) => {
        if (this.items && this.selection?.selectedOptions?.selected.length === 0 && typeof value?.[0] === 'object') {
          const updatedReferences = [];
          this.items.forEach((item) => {
            value.forEach((option) => {
              if (this.getItemLabel(item) === this.getItemLabel(option))
                updatedReferences.push(item);
            });
          });
          this.formControl.setValue(updatedReferences);
        }
      })
    }
  }


  getItemValue(item: any): any {
    if (this.itemValue) {
      return item[this.itemValue];
    }
    return item;
  }

  getItemLabel(item: any): any {
    if (this.itemLabel) {
      return item[this.itemLabel]
    }
    return item
  }
}
